module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp13_6000.fa32e105.png";